import { Controller } from "stimulus"
import Player from "../media/player"
import Plyr from "plyr"

export default class extends Controller {

    static targets = ['player', 'playlistItem'];

    connect() {
        const player = Player.createFromMarkup(this.element);
        this.element.innerHTML = player.render();
        this.plyrs = Array.from(this.element.getElementsByClassName('media-plyr')).map(p => new Plyr(p));
        this.updateSelected(player.items[0].id);
    }

    selectItem(e) {
        e.preventDefault();

        this.plyrs.forEach(plyr => plyr.pause());
        this.updateSelected(e.target.getAttribute('href').replace('#media-', ''));

        setTimeout(() => {
            this.element.setAttribute('tabindex', '-1');
            this.element.focus({ preventScroll: true });
            this.element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 300);
    }

    updateSelected(id) {
        this.playerTargets.forEach(el => {
            const isHidden = (el.id != 'media-' + id);

            el.classList.toggle('hidden', isHidden);
            el.setAttribute('aria-hidden', isHidden ? 'true' : 'false');
        });

        this.playlistItemTargets.forEach(el => {
            const isSelected = (el.id == 'media-' + id + '-playlist-item');

            el.classList.toggle('media-js-item-selected', isSelected);
            el.setAttribute('aria-current', isSelected ? 'true' : 'false');
        });
    }

    toggleTranscript(e) {
        e.preventDefault();

        const toggleText = e.target.innerHTML;

        if (toggleText.startsWith('Show')) {
            var currentVerb = 'Show';
            var newVerb = 'Hide';
        } else {
            var currentVerb = 'Hide';
            var newVerb = 'Show';
        }

        e.target.innerHTML = toggleText.replace(currentVerb, newVerb);

        document.getElementById(
            e.target.getAttribute('href').replace('#', '')
        ).classList.toggle('hidden');
    }
}
